import Checkbox from '@mui/material/Checkbox';
import { ChangeEvent, useEffect, useState } from 'react';
import './style.css';

export interface CheckboxProps {
  value: boolean;
  onChange: (value: boolean) => void;
  label: { inputProps: { 'aria-label': string } };
  isChecked?: boolean;
  isDisabled?: boolean;
}

export default function CheckboxInput({ value, onChange, label, isChecked = false, isDisabled = false }: CheckboxProps) {
  const [checked, setChecked] = useState(value);

  const handleChange = ({ target }: ChangeEvent<HTMLInputElement>) => {
    setChecked(target.checked);
    onChange(target.checked);
  };

  useEffect(() => {
    setChecked(value);
  }, [value]);

  return (
    <div className="container-checkbox">
        <Checkbox
            {...label}
            checked={checked}
            onChange={handleChange}
            disabled={isDisabled}
        />
        {label.inputProps['aria-label']}
    </div>
    );
}